import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { Router } from '@angular/router';
import { EmpresasService } from '../../../services/empresa/empresas.service';
import { GrupoEmpresa } from '../../../models/GrupoEmpresa';
import { AuthService } from '../../../services/auth/auth.service';
import { clearPaginas, pushPaginaAtiva } from '../../../shared/activePage';

@Component({
  selector: 'app-listar-grupos',
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    MatSortModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './listar-grupos.html',
  styleUrl: './listar-grupos.scss'
})
export class ListarGrupos implements OnInit {

  public isLoading = false;

  grupos: GrupoEmpresa[] = [];
  filteredGrupos: GrupoEmpresa[] = [];
  searchFilter: string = '';
  temEmpresasNoSistema: boolean = true;

  constructor(
    private readonly router: Router,
    private readonly empresasService: EmpresasService,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: '/home'
    });
    pushPaginaAtiva({
        nome: 'Grupo de empresas',
        rota: ''
    });
    this.verificarEmpresas();
    this.carregarGrupos();
  }

  private async carregarGrupos(): Promise<void> {
    try {
      this.isLoading = true;
      this.empresasService.buscarGruposVinculadosAoUsuario().subscribe({
        next: (grupos) => {
          this.grupos = grupos;
          this.filteredGrupos = [...this.grupos];
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Erro ao carregar grupos:', error);
          this.isLoading = false;
        }
      });
    } catch (error) {
      console.error('Erro ao carregar grupos:', error);
      this.isLoading = false;
    }
  }

  filterGrupos(): void {
    if (!this.searchFilter.trim()) {
      this.filteredGrupos = [...this.grupos];
    } else {
      this.filteredGrupos = this.grupos.filter(grupo =>
        grupo.nome.toLowerCase().includes(this.searchFilter.toLowerCase())
      );
    }
  }

  navegarParaCadastroEmpresa(): void {
    this.router.navigate(['/empresas/cadastrar']);
  }

  navegarParaCadastroGrupo(): void {
    this.router.navigate(['/grupos/cadastrar']);
  }

  acessarGrupo(grupoId: number): void {
    this.router.navigate(['/grupos/editar', grupoId]);
  }

  private async verificarEmpresas(): Promise<void> {
    try {
      const empresas = await this.empresasService.findAllEmpresas();
      this.temEmpresasNoSistema = empresas && empresas.length > 0;
    } catch (error) {
      console.error('Erro ao verificar empresas:', error);
      this.temEmpresasNoSistema = false;
    }
  }

  isMasterUser(): boolean {
    return this.authService.isMasterUser();
  }
}
